import { addDoc, deleteDoc } from "firebase/firestore";
import {
  fromDocumentData,
  getCollectionRef,
  getDocumentRef,
  onCollectionSnapshot,
  toDocumentData,
  updateDocument,
} from "./FirebaseRepository";
import DiscountModel from "../models/DiscountModel";

class DiscountRepository {
  private path = (contractUid: string) => `cfContract/${contractUid}/discounts`;

  public async addDiscountToDataBase(data: DiscountModel): Promise<string> {
    const collection = getCollectionRef(
      this.path(data.contractUid),
      converter(data.contractUid)
    );
    const doc = await addDoc(collection, data);
    return doc.id;
  }

  public deleteDiscountFromDataBase(contractUid: string, uid: string) {
    const doc = getDocumentRef(this.path(contractUid), uid);
    return deleteDoc(doc);
  }

  public updateDiscountOnDataBase(
    contractUid: string,
    uid: string,
    updatedData: Partial<DiscountModel>,
    transaction?: any
  ) {
    const doc = getDocumentRef(this.path(contractUid), uid);
    const data = converter(contractUid).toFirestore(updatedData);
    return updateDocument(doc, data, transaction);
  }

  addDiscountsCollectionSnapshot(
    contractUid: string,
    onCreate: (data: DiscountModel[]) => void,
    onChange: (data: DiscountModel[]) => void,
    onRemove: (data: DiscountModel[]) => void
  ) {
    const collection = getCollectionRef(
      this.path(contractUid),
      converter(contractUid)
    );
    return onCollectionSnapshot<DiscountModel>(
      collection,
      onCreate,
      onChange,
      onRemove,
      (error) => console.error("DiscountSnapshot", error)
    );
  }
}

// Firestore data converter
const converter = (contractUid) => ({
  toFirestore: (discount: Partial<DiscountModel>) => {
    const data =
      discount instanceof DiscountModel ? discount.toSave() : discount;
    return toDocumentData(data);
  },
  fromFirestore: (snapshot, options) => {
    let data = snapshot.data(options);
    data = fromDocumentData(data);
    return DiscountModel.create(snapshot.id, {
      ...data,
      contractUid,
    });
  },
});

export default new DiscountRepository();
